import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ButtonComponent } from 'app/shared/components/button/button.component';
import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';

import { IButtonConfig } from 'app/shared/interfaces/button.interfaces';
import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { EButtonSizes, EButtonTypes } from 'app/shared/enums/button.enums';

@Component({
  selector: 'stxt-subscription-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, SvgIconComponent],
  templateUrl: './subscription-modal.component.html',
  styleUrl: './subscription-modal.component.scss'
})
export class SubscriptionModalComponent {
  @Input() creatorData: {
    creator_name?: string;
    thumbnail_image?: string;
    name?: string;
    image?: string;
  };
  @Input() subscriptionPrice: number;
  @Input() isVoiceCallEnabled: boolean;
  @Output() openPayment: EventEmitter<void> = new EventEmitter<void>();
  public closeSvg: ISvgConfig = { fill: ESvgTypes.Tonal, name: 'close' };
  public chatSvg: ISvgConfig = { fill: ESvgTypes.None, name: 'speech-balloon' };
  public crownSvg: ISvgConfig = { fill: ESvgTypes.None, name: 'crown' };
  public giftSvg: ISvgConfig = { fill: ESvgTypes.None, name: 'gift' };
  public heartSvg: ISvgConfig = { fill: ESvgTypes.None, name: 'heart' };
  public lipsSvg: ISvgConfig = { fill: ESvgTypes.None, name: 'lips' };
  public subscribeBtn: IButtonConfig = {
    text: 'Subscribe now',
    fill: EButtonTypes.SecondaryFilled,
    buttonSize: EButtonSizes.Default
  };

  constructor(public activeModal: NgbActiveModal) {}

  openPaymentEvent(): void {
    this.activeModal.close('payment');
  }
}
